import * as React from 'react';
import { IndexRoute, Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import ConsumerPageWrapper from 'bundles/degree-description/pages/consumer/ConsumerPageWrapper';
import AcademicsPageContent from 'bundles/degree-description/pages/consumer/degree-description-page/subpages/AcademicsPageContent';
import AdmissionsPageContent from 'bundles/degree-description/pages/consumer/degree-description-page/subpages/AdmissionsPageContent';
import CareersPageContent from 'bundles/degree-description/pages/consumer/degree-description-page/subpages/CareersPageContent';
import OverviewPageContent from 'bundles/degree-description/pages/consumer/degree-description-page/subpages/OverviewPageContent';
import StudentExperiencePageContent from 'bundles/degree-description/pages/consumer/degree-description-page/subpages/StudentExperiencePageContent';
import TuitionPageContent from 'bundles/degree-description/pages/consumer/degree-description-page/subpages/TuitionPageContent';
import { NAVIGATION_PARENT_ITEMS } from 'bundles/degree-description/utils/utils';
import NotFound from 'bundles/phoenix/components/NotFound';

const DegreeDescriptionPageRoot = loadOnRoute(
  () => import('bundles/degree-description/pages/consumer/degree-description-page/DegreeDescriptionPageRoot')
);

const reactRoute = (
  <Route name="degree-description">
    <Route name="consumer" path="/" component={ConsumerPageWrapper}>
      {/* Dev routes */}
      <Route
        name={NAVIGATION_PARENT_ITEMS.internalOnly}
        path="degree-description/:slug"
        getComponent={DegreeDescriptionPageRoot}
      >
        <IndexRoute name="overview" component={OverviewPageContent} />

        <Route name="admissions" component={AdmissionsPageContent} path="admissions" />
        <Route name="admisiones" component={AdmissionsPageContent} path="admisiones" />

        <Route name="academics" component={AcademicsPageContent} path="academics" />
        <Route name="plan-de-estudios" component={AcademicsPageContent} path="plan-de-estudios" />

        <Route name="tuition-financing" component={TuitionPageContent} path="tuition-financing" />
        <Route name="costos-y-becas" component={TuitionPageContent} path="costos-y-becas" />

        <Route name="careers" component={CareersPageContent} path="careers" />
        <Route name="carreras-profesionales" component={CareersPageContent} path="carreras-profesionales" />

        <Route name="student-experience" component={StudentExperiencePageContent} path="student-experience" />
        <Route
          name="experiencia-del-estudiante"
          component={StudentExperiencePageContent}
          path="experiencia-del-estudiante"
        />
      </Route>

      {/* Prod routes */}
      <Route name={NAVIGATION_PARENT_ITEMS.production} path="degrees/:slug" getComponent={DegreeDescriptionPageRoot}>
        <IndexRoute name="overview" component={OverviewPageContent} />

        <Route name="admissions" component={AdmissionsPageContent} path="admissions" />
        <Route name="admisiones" component={AdmissionsPageContent} path="admisiones" />

        <Route name="academics" component={AcademicsPageContent} path="academics" />
        <Route name="plan-de-estudios" component={AcademicsPageContent} path="plan-de-estudios" />

        <Route name="tuition-financing" component={TuitionPageContent} path="tuition-financing" />
        <Route name="costos-y-becas" component={TuitionPageContent} path="costos-y-becas" />

        <Route name="careers" component={CareersPageContent} path="careers" />
        <Route name="carreras-profesionales" component={CareersPageContent} path="carreras-profesionales" />

        <Route name="student-experience" component={StudentExperiencePageContent} path="student-experience" />
        <Route
          name="experiencia-del-estudiante"
          component={StudentExperiencePageContent}
          path="experiencia-del-estudiante"
        />
      </Route>
    </Route>

    <Route component={NotFound} path="*" />
  </Route>
);

export default reactRoute;
